import React from "react";

export const EMPTY_ADV = {
  from: "",
  to: "",
  area: "",
  minRisk: "",
  maxRisk: "",
  status: [],
  severity: [],
  overdueOnly: false,
  lateOnly: false,
  onlyOpen: false,
  onlyClosed: false,
  assignees: [],
};

export default function UAUCAllAdvancedFilters({
  adv,
  setAdv,
  assigneeOptions,
}) {
  const activeText = [
    adv.from && `From ${adv.from}`,
    adv.to && `To ${adv.to}`,
    adv.area && `Area "${adv.area}"`,
    (adv.minRisk || adv.maxRisk) &&
      `Risk ${adv.minRisk || 0}-${adv.maxRisk || "max"}`,
    adv.status.length && `Status: ${adv.status.join(", ")}`,
    adv.severity.length && `Severity: ${adv.severity.join(", ")}`,
    adv.assignees.length && `Assignees: ${adv.assignees.length}`,
    adv.onlyOpen && "Only Open",
    adv.onlyClosed && "Only Closed",
    adv.overdueOnly && "Overdue Only",
    adv.lateOnly && "Closed Late Only",
  ]
    .filter(Boolean)
    .join(" | ");

  return (
    <div className="grid grid-cols-1 gap-3 border-b border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-4">
      <label className="text-xs font-bold text-slate-600">
        From Opened
        <input
          type="date"
          className="mt-1 h-10 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm"
          value={adv.from}
          onChange={(e) =>
            setAdv((state) => ({ ...state, from: e.target.value }))
          }
        />
      </label>

      <label className="text-xs font-bold text-slate-600">
        To Opened
        <input
          type="date"
          className="mt-1 h-10 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm"
          value={adv.to}
          onChange={(e) =>
            setAdv((state) => ({ ...state, to: e.target.value }))
          }
        />
      </label>

      <label className="text-xs font-bold text-slate-600">
        Area Contains
        <input
          className="mt-1 h-10 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm"
          placeholder="e.g. TG Deck"
          value={adv.area}
          onChange={(e) =>
            setAdv((state) => ({ ...state, area: e.target.value }))
          }
        />
      </label>

      <div className="flex gap-2">
        <label className="flex-1 text-xs font-bold text-slate-600">
          Min Risk
          <input
            type="number"
            className="mt-1 h-10 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm"
            value={adv.minRisk}
            onChange={(e) =>
              setAdv((state) => ({ ...state, minRisk: e.target.value }))
            }
          />
        </label>

        <label className="flex-1 text-xs font-bold text-slate-600">
          Max Risk
          <input
            type="number"
            className="mt-1 h-10 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm"
            value={adv.maxRisk}
            onChange={(e) =>
              setAdv((state) => ({ ...state, maxRisk: e.target.value }))
            }
          />
        </label>
      </div>

      <label className="text-xs font-bold text-slate-600">
        Status
        <select
          multiple
          className="mt-1 h-24 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm"
          value={adv.status}
          onChange={(e) =>
            setAdv((state) => ({
              ...state,
              status: Array.from(
                e.target.selectedOptions,
                (option) => option.value,
              ),
            }))
          }
        >
          <option value="open">Open</option>
          <option value="closed">Closed</option>
          <option value="resolved">Resolved</option>
          <option value="in-progress">In-Progress</option>
        </select>
      </label>

      <label className="text-xs font-bold text-slate-600">
        Severity
        <select
          multiple
          className="mt-1 h-24 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm"
          value={adv.severity}
          onChange={(e) =>
            setAdv((state) => ({
              ...state,
              severity: Array.from(
                e.target.selectedOptions,
                (option) => option.value,
              ),
            }))
          }
        >
          <option value="Low">Low</option>
          <option value="Moderate">Moderate</option>
          <option value="High">High</option>
          <option value="Critical">Critical</option>
        </select>
      </label>

      <label className="text-xs font-bold text-slate-600">
        Assignees
        <select
          multiple
          className="mt-1 h-24 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm"
          value={adv.assignees}
          onChange={(e) =>
            setAdv((state) => ({
              ...state,
              assignees: Array.from(
                e.target.selectedOptions,
                (option) => option.value,
              ),
            }))
          }
        >
          {assigneeOptions.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>
      </label>

      <div className="flex flex-col gap-2 text-sm font-bold text-slate-700">
        <span className="text-xs font-black uppercase tracking-wide text-slate-500">
          Quick Toggles
        </span>

        <label className="inline-flex items-center gap-2">
          <input
            type="checkbox"
            checked={adv.onlyOpen}
            onChange={(e) =>
              setAdv((state) => ({
                ...state,
                onlyOpen: e.target.checked,
                onlyClosed: e.target.checked ? false : state.onlyClosed,
              }))
            }
          />
          Only Open
        </label>

        <label className="inline-flex items-center gap-2">
          <input
            type="checkbox"
            checked={adv.onlyClosed}
            onChange={(e) =>
              setAdv((state) => ({
                ...state,
                onlyClosed: e.target.checked,
                onlyOpen: e.target.checked ? false : state.onlyOpen,
              }))
            }
          />
          Only Closed
        </label>

        <label className="inline-flex items-center gap-2">
          <input
            type="checkbox"
            checked={adv.overdueOnly}
            onChange={(e) =>
              setAdv((state) => ({ ...state, overdueOnly: e.target.checked }))
            }
          />
          Overdue Only
        </label>

        <label className="inline-flex items-center gap-2">
          <input
            type="checkbox"
            checked={adv.lateOnly}
            onChange={(e) =>
              setAdv((state) => ({ ...state, lateOnly: e.target.checked }))
            }
          />
          Closed Late Only
        </label>
      </div>

      <div className="col-span-full flex flex-wrap items-center gap-3">
        <button
          type="button"
          className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-xs font-black text-slate-700"
          onClick={() => setAdv(EMPTY_ADV)}
        >
          Reset Filters
        </button>

        {activeText && (
          <span className="text-xs font-bold text-slate-500">{activeText}</span>
        )}
      </div>
    </div>
  );
}
